import { HttpClient } from '@angular/common/http'
import { CustomTranslateHttpLoader } from '@core/i18n/custom-translate-http.loader'

export function HttpLoaderFactory(http: HttpClient) {
  return new CustomTranslateHttpLoader(http)
}
